import { createContext, useState, useContext } from 'react';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [credActivo, setCredActivo] = useState(null);

    // useEffect(() => {
    //     getEstadoAccesoCredenciales()
    //         .then((acceso) => {
    //             setCredActivo(acceso);
    //         })
    //         .catch(() => {
    //             setCredActivo(false);
    //         });
    // }, []);

    return (
        <AuthContext.Provider value={{ credActivo, setCredActivo }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthentication = () => useContext(AuthContext);
